export const orderWithoutCDE: string[] = [
  "Logistics",
  "Manufacturing",
  "Packaging",
  "Ingredients",
];

export const orderWithCDE: string[] = ["CDE", ...orderWithoutCDE];
